import repository from "@/plugins/axios/secureClient";

// set new axios instance
export default repository;
